import React from "react";

import LegalPageLayout from "@/components/LegalPageLayout";
import {
  HOME_META,
  PRIVACY_PAGE_INTRO,
  PRIVACY_PATH,
  PRIVACY_SECTIONS,
  PRIVACY_SUMMARY_CARDS,
} from "@/content/siteContent";
import { usePageSEO } from "@/hooks/usePageSEO";

export default function PrivacyPolicyPage() {
  usePageSEO({
    title: "Privacy Policy Fanta Royal",
    description:
      "Informativa Privacy di Fanta Royal: dati trattati, finalità, pagamenti ticket, diritti dell’utente e struttura legale modificabile per il progetto.",
    canonicalPath: PRIVACY_PATH,
    keywords: `${HOME_META.keywords}, privacy policy fanta royal`,
  });

  return (
    <LegalPageLayout
      kicker="Privacy Policy"
      title="Informativa Privacy"
      intro={PRIVACY_PAGE_INTRO}
      summaryCards={PRIVACY_SUMMARY_CARDS}
      sections={PRIVACY_SECTIONS}
      ctaLabel="Vai al ticket"
    />
  );
}
